import { useState, useRef, useEffect } from "react"
import './ContactEmails.css'

export default function ContactEmails({emails, onClose}) {

    const dialogRef = useRef(null)
    const [copiedEmail, setCopiedEmail] = useState(null)
    const timeoutId = useRef(null)

    useEffect(() => {
        dialogRef.current.showModal()
    }, [])

    const copyEmail = (email) => {
        navigator.clipboard.writeText(email)
        if (timeoutId.current) clearTimeout(timeoutId.current)
        setCopiedEmail(email)
        timeoutId.current = setTimeout(() => setCopiedEmail(null), 2000)
    }

    const handleBackdropClick = (e) => {
        if (e.target === dialogRef.current) onClose()
    }

    return(<dialog ref={dialogRef} onClose={onClose} onClick={handleBackdropClick} className="contact-dialog">
        <div className="card">
            <div className="flex center space-between">
                <p className="card-title">Have a Question?</p>
                <button className="icon outline" onClick={onClose}><span className="material-symbols-outlined">close</span></button>
            </div>
            <div className="flex columns gap-xs vi-spacer-m">
                <p className="card-body text-center padding-xs v-spacer-xxs">If you have any questions, please feel free to contact us directly at the email(s) addresses provided below.</p>
                {emails?.map(email => <div key={email} className="dashed-card space-between standard-padding-xs">
                    <p className="card-body medium">{email}</p>
                    <button className="elevated" onClick={() => copyEmail(email)}>{copiedEmail == email ? 'Copied' : 'Copy'}</button>
                </div>)}
            </div>
        </div>
    </dialog>)
}